import React, { FC, PropsWithChildren } from 'react'
import { cn } from '../../utils/cn'

interface CardFooterProps {
  className?: string
}

export const CardFooter: FC<PropsWithChildren<CardFooterProps>> = ({
  children,
  className
}) => (
  <footer
    className={cn(
      'rounded-b-lg bg-blue-50 px-4 py-3 text-sm font-light leading-none text-slate-950',
      className
    )}>
    {children}
  </footer>
)
